<script>
import { mapActions, mapMutations } from "vuex";
import TownhousePricelist from "./townhousePricelist.vue";
import ApartmentPricelist from "./apartmentPricelist.vue";
import HousePricelist from "./housePricelist.vue";
import LandPricelist from "./landPricelist.vue";
import HouseAndLandPricelist from "./houseAndLandPricelist.vue";
import {regexPatterns} from "../../utils/utils";
import {countries} from "../../utils/countries";
import confetti from "canvas-confetti";
import {validateToken} from "../../utils/tokenUtils";

export default {
  name: "priceListSection",
  components: {
    HouseAndLandPricelist,
    LandPricelist,
    HousePricelist,
    ApartmentPricelist,
    TownhousePricelist
  },
  data() {
    return {
      activeNames: ["1"],
      list: [],
      showReserve: true,
      pm: {},
      loading: true,
      page: '',
      revealPriceListForm: {
        firstName: '',
        lastName: '',
        email: '',
        mobileNumber: '',
        countryCode: '+61',
      },
      userLoggedIn: false,
      revealPriceListFormRules: {
        firstName: [
          { required: true, message: 'Please provide your first name', trigger: 'none' }
        ],
        lastName: [
          { required: true, message: 'Please provide your last name', trigger: 'none' }
        ],
        email: [
          { required: true, message: 'Your email is required to proceed',  trigger: 'blur', pattern: regexPatterns.email }
        ],
      },
      formSubmitted: false,
    };
  },
  props: {
    propsData: Array,
    propsProerty: String,
    current: Object
  },
  mounted() {
    this.populateRevealingPriceListForm();
    this.revealPriceListForLoggedAndRevealedUser();
  },
  created() {
    var that = this;
    that.pm = that.$route.params;
    if (this.propsData.length > 0) {
      let temp = [];
      this.propsData.forEach((v, i) => {
        if (i == 0) v.unfold = true;
        else v.unfold = false;
        if (v.status == "Reserved") {
          v.class = "grn";
        } else if (
          v.status == "Sold" ||
          v.status == "Unconditional" ||
          v.status == "Settled"
        ) {
          v.class = "prl";
        }
        temp.push(v);
      });
      this.list = temp;
      this.loading = false;
    }
  },
  methods: {
    ...mapActions("price", ["getLst"]),
    ...mapMutations("login", ["cleartime"]),
    ...mapActions("revealPriceList", ["revealPriceList", "checkPropertyRevealedByUser"]),
    ...mapActions("account", ["retrieveMinimalUserForRevealPriceList"]),
    redirectToTcAndPp(key) {
      if (this.page == key) {
        this.reload()
      }
      switch (key) {
        case "terms":
          this.act = "terms"
          window.open("https://s3.ap-southeast-2.amazonaws.com/com.unifiproperty/docs/terms-and-conditions/UNIFI-Property-Terms-and-Conditions.pdf", '_blank');
          break;
        case "privacy":
          this.act = "privacy"
          window.open("https://s3.ap-southeast-2.amazonaws.com/com.unifiproperty/docs/privacy-policy/UNIFI-Property-Privacy-Policy.pdf", '_blank');
          break;
        case "join":
          localStorage.setItem('previousPath', this.$route.fullPath);
          this.act = "join"
          this.$router.push({path: "/register"});
          break;
        default:
          let path = this.$route.path
          this.act = Utils.getActiveType(path)
          break;
      }
    },
    countries() {
      return countries
    },
    handleSubmit() {
      console.log("current", this.current);
      let pat = {
        firstName: this.revealPriceListForm.firstName,
        lastName: this.revealPriceListForm.lastName,
        email: this.revealPriceListForm.email,
        countryCode: this.revealPriceListForm.countryCode,
        mobileNumber: this.revealPriceListForm.mobileNumber,
        propertyId: this.current.propertyId,
      };
      this.$refs.revealPricelistForm.validate(valid => {
        if (valid) {
          this.$box.loadings(3);
          this.revealPriceList({
            params: pat,
            callback: this.revealPriceListCallback
          });
        } else {
          this.$box.loadings(2);
          this.$box.alert("", "Please fill the mandatory fields", "error");
          return false;
        }
      });
    },
    confettiAnimation() {
      confetti({
        particleCount: 200,
        angle: 60,
        spread: 70,
        origin: { x: 0 }
      });
      // and launch a few from the right edge
      confetti({
        particleCount: 200,
        angle: 120,
        spread: 70,
        origin: { x: 1 }
      });
    },
    revealPriceListCallback(res) {
      this.$box.loadings(2);
      if (res.data.code == 0) {
        this.$box.alert("", "Thank you! The price list is unlocked", "success");
        this.confettiAnimation();
        this.formSubmitted = true; // Hide the form and reveal the table
      } else {
        this.$box.alert("", res.data.message, "error");
      }
    },
    populateRevealingPriceListForm() {
      const tokenValidation = validateToken();
      if (tokenValidation.isValid) {
        this.$box.loadings(3);
        this.retrieveMinimalUserForRevealPriceList({
          callback: this.retrieveMinimalUserCallback
        });
      }
    },
    retrieveMinimalUserCallback(res) {
      this.$box.loadings(2);
      if (res.data.code == 0) {
        this.user = res.data.data;
        this.revealPriceListForm.firstName = this.user.firstName;
        this.revealPriceListForm.lastName = this.user.lastName;
        this.revealPriceListForm.email = this.user.email;
        this.revealPriceListForm.countryCode = this.user.countryCode;
        this.revealPriceListForm.mobileNumber = this.user.mobileNumber;
        this.userLoggedIn = true;
      } else {
        this.userLoggedIn = false;
        this.$box.alert("", res.data.message, "error");
      }
    },
    revealPriceListForLoggedAndRevealedUser() {
      const tokenValidation = validateToken();
      if (tokenValidation.isValid) {
        const token = localStorage.getItem("token");
        const payload = JSON.parse(atob(token.split('.')[1]));
        const userDetails = JSON.parse(payload.sub);

        const params = {
          propertyId: this.current.propertyId,
          userId: userDetails.userId
        }
        this.checkPropertyRevealedByUser({
          params: params,
          callback: this.checkPropertyRevealedByUserCallback
        })
      }
    },
    checkPropertyRevealedByUserCallback(res) {
      this.$box.loadings(2);
      if (res.data.code == 0) {
        this.formSubmitted = res.data.data;
      } else {
        this.formSubmitted = false;
      }
    },
    unfold(i) {
      var that = this;
      let temp = JSON.parse(JSON.stringify(that.list));
      let status = !temp[i].unfold;
      temp.forEach(v => {
        v.unfold = false;
      });
      temp[i].unfold = status;
      that.list = [];
      this.$nextTick(() => {
        that.list = temp;
      });
      let currentRow = {};
      if (status) currentRow = temp[i];
      this.$emit("updateRow", currentRow);
    },
    callback(res) {
      var that = this;
      that.loading = false;
      if (res.data.code == 0) {
        res.data.data.forEach((v, i) => {
          v.unfold = false;
          if (
            v.revisedPrice !== undefined &&
            JSON.stringify(v.revisedPrice).indexOf(".") !== -1
          ) {
            v.revisedPrice = that.$box.formatSplit(v.revisedPrice, true);
          } else {
            v.revisedPrice = that.$box.formatSplit(v.revisedPrice, true);
          }

          if (
            v.landPrice !== undefined &&
            JSON.stringify(v.landPrice).indexOf(".") !== -1
          ) {
            v.landPrice = that.$box.formatSplit(v.landPrice, true);
          } else {
            v.landPrice = that.$box.formatSplit(v.landPrice, true);
          }

          if (
            v.buildingPrice !== undefined &&
            JSON.stringify(v.buildingPrice).indexOf(".") !== -1
          ) {
            v.buildingPrice = that.$box.formatSplit(v.buildingPrice, true);
          } else {
            v.buildingPrice = that.$box.formatSplit(v.buildingPrice, true);
          }
          if (
            v.revisedPriceMax !== undefined &&
            JSON.stringify(v.revisedPriceMax).indexOf(".") !== -1
          ) {
            v.revisedPriceMax = that.$box.formatSplit(v.revisedPriceMax, true);
          } else {
            v.revisedPriceMax = that.$box.formatSplit(v.revisedPriceMax, true);
          }

          if (
            v.anticipatedRent !== undefined &&
            JSON.stringify(v.anticipatedRent).indexOf(".") !== -1
          ) {
            v.anticipatedRent = that.$box.formatSplit(v.anticipatedRent, true);
          } else {
            v.anticipatedRent = that.$box.formatSplit(v.anticipatedRent, true);
          }

          if (
            v.anticipatedRentMax !== undefined &&
            JSON.stringify(v.anticipatedRentMax).indexOf(".") !== -1
          ) {
            v.anticipatedRentMax =
              v.anticipatedRentMax !== 0
                ? that.$box.formatSplit(v.anticipatedRentMax, true)
                : null;
          } else {
            v.anticipatedRentMax =
              v.anticipatedRentMax !== 0
                ? that.$box.formatSplit(v.anticipatedRentMax, true)
                : null;
          }

          if (v.status == "Reserved") {
            v.class = "grn";
          } else if (
            v.status == "Sold" ||
            v.status == "Unconditional" ||
            v.status == "Settled"
          ) {
            v.class = "prl";
            v.status = "Sold";
          }

          if (v.balcony === 0) {
            v.balcony = "N/A";
          }
          if (v.baths === 0) {
            v.baths = "Studio";
          }
          if (v.beds === 0) {
            v.beds = "N/A";
          }
          if (v.cars === 0) {
            v.cars = "N/A";
          }
          if (v.internal === 0) {
            v.internal = "N/A";
          }
          if (v.storage === "0" || v.storage === "" || v.storage === null) {
            v.storage = "N/A";
          }
          if (v.anticipatedRent === 0) {
            v.anticipatedRent = "N/A";
          }
          if (v.revisedPrice === 0) {
            v.revisedPrice = "N/A";
          }
          if (v.total === 0) {
            v.total = "N/A";
          }
        });
      } else if (
        res.data.code == 90000 ||
        res.data.code == 90002 ||
        res.data.code == 8902 ||
        res.data.code == 8901
      ) {
        that.$box.alert("", res.data.message, "error");
        localStorage.clear();
        that.$router.push("/login");
      }
    },
  }
};
</script>

<template>
  <div class="pricelist-container">
    <div :class="{ blurBackground: !this.formSubmitted }">
      <div style="padding-top: 10px;">
        <div v-for="(item, index) in list" :key="index">
      <townhouse-pricelist
        v-if="propsProerty == 'Townhouses'"
        :property="item"
        :defaultExpanded="index === 0"
      />
      <apartment-pricelist
        v-if="propsProerty == 'Apartments'"
        :property="item"
        :defaultExpanded="index === 0"
      />
      <house-pricelist
        v-if="propsProerty == 'House'"
        :property="item"
        :default-expanded="index === 0"
      />
      <land-pricelist
        v-if="propsProerty == 'Land'"
        :property="item"
        :default-expanded="index === 0"
      />
      <house-and-land-pricelist
        v-if="propsProerty == 'House & Land'"
        :property="item"
        :default-expanded="index === 0"
      />
    </div>
      </div>
    </div>
    <div class="overlay center-box" v-if="!formSubmitted">
<!--      <div class="animated-border-box-glow"></div>-->
      <div class="form-wrapper border-box-temp-glow">
        <el-form ref="revealPricelistForm" :model="revealPriceListForm" :rules="revealPriceListFormRules" :hide-required-asterisk="true">
          <el-row :gutter="20" style="padding: 10px">
            <el-col :span="24">
              <span class="title-reveal-pricelist-section">Enter your details to gain
                <span class="important-word">instant</span>
                access to our exclusive price list
              </span>
              <el-divider></el-divider>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="24">
              <span>First Name</span>
              <el-form-item prop="firstName" class="mt-5">
                <el-input placeholder="Please provide your first name" v-model="revealPriceListForm.firstName"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="24">
              <span>Last Name</span>
              <el-form-item prop="lastName" class="mt-5">
                <el-input placeholder="Please provide your last name" v-model="revealPriceListForm.lastName"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="24">
              <span>Email</span>
              <el-form-item prop="email" class="mt-5">
                <el-input placeholder="Your email is required to proceed" v-model="revealPriceListForm.email"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="24">
              <span>Mobile Number</span>
              <el-row :gutter="20"  class="mt-5">
                <el-col :span="10">
                  <el-form-item prop="countryCode">
                    <el-select
                      v-model="revealPriceListForm.countryCode"
                      placeholder="Country Code"
                      filterable
                    >
                      <el-option
                        v-for="country in countries()"
                        :key="country.code"
                        :label="`${country.code} ${country.dialCode}`"
                        :value="country.dialCode">
                        <span><b>{{ country.name }}</b> <span style="color: #9a9a9a">({{ country.code }})</span> {{ country.dialCode }}</span>
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="14">
                  <el-form-item prop="mobileNumber">
                    <el-input placeholder="Providing your mobile number is optional but helps us assist you better" v-model="revealPriceListForm.mobileNumber"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="24" class="mt-10">
              <el-button class="reveal-btn" @click="handleSubmit">REVEAL PRICE LIST <i class="el-icon-view"></i></el-button>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="24">
              <span class="tc-pp">* By submitting, you have read, understood and agreed to our
                <span @click="redirectToTcAndPp('terms')" class="tcpp-link">Terms of use</span>
                and
                <span @click="redirectToTcAndPp('privacy')" class="tcpp-link">Privacy policy</span>
              </span>
            </el-col>
          </el-row>
        </el-form>
        <div v-show="!userLoggedIn">
          <el-divider direction="horizontal"/>
          <el-row :gutter="20">
            <el-col :span="24" style="text-align: center">
                <span class="join-now">Streamline your experience - register now to reveal prices effortlessly.
                  <span @click="redirectToTcAndPp('join')" class="join-now-link">Start Here...</span>
                </span>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>

.pricelist-container {
  position: relative;
  margin: 0;
  padding: 0;
  overflow: hidden;
  min-height: 85vh;
}

.overlay {
  position: absolute; /* Position the form overlay within the pricelist section */
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.7); /* Semi-transparent to allow viewing content */
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
}

.form-wrapper {
  max-width: 70%;
  width: 90%;
  background-color: rgba(255, 255, 255, 0.9);
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
}

.blurBackground {
  filter: blur(5px);
  transition: filter 0.3s ease;
  z-index: 1;
  position: relative;
}



.animated-border-box, .animated-border-box-glow{
  width: 100%;
  position: absolute;
  overflow: hidden;
  z-index: 0;
  border-radius: 10px;
}

.animated-border-box-glow{
  overflow: hidden;
  /* Glow Blur */
  filter: blur(5px);
}

.animated-border-box:before, .animated-border-box-glow:before {
  content: '';
  z-index: -2;
  text-align: center;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) rotate(0deg);
  position: absolute;
  width: 99999px;
  height: 99999px;
  background-repeat: no-repeat;
  background-position: 0 0;
  /*background-image: conic-gradient(rgba(0,0,0,0), #00CC99, rgba(0,0,0,0) 25%);*/
  background-image: conic-gradient(
      rgba(0, 51, 51, 0) 0%,       /* Transparent start */
      rgba(0, 204, 153, 1) 20%,    /* Neon Turquoise */
      rgba(0, 153, 153, 1) 40%,    /* Neon Teal */
      rgba(0, 102, 102, 1) 60%,    /* Darker Teal */
      rgba(102, 255, 204, 1) 80%,  /* Bright Aqua */
      rgba(0, 51, 51, 1) 100%,     /* Original Dark Teal for loop */
      rgba(0, 51, 51, 0) 120%      /* Ends with transparent dark teal */
  );
  box-shadow: 0 0 10px 5px rgba(153, 153, 51, 0.5); /* Example glow for a yellowish neon */
  animation: rotate 8s linear infinite;
}

@keyframes glow {
  0%, 100% {
    box-shadow: 0 0 10px 5px rgba(153, 153, 51, 0.5);
  }
  50% {
    box-shadow: 0 0 20px 10px rgba(153, 153, 51, 0.7);
  }
}

.glowing-element {
  background-image: conic-gradient(
      rgba(0, 51, 51, 0) 0%,
      rgba(0, 204, 153, 1) 20%, /* Neon Turquoise */
      rgba(0, 153, 153, 1) 40%, /* Neon Teal */
      rgba(0, 102, 102, 1) 60%, /* Darker Teal */
      rgba(102, 255, 204, 1) 80%, /* Bright Aqua */
      rgba(0, 51, 51, 1) 100%, /* Dark Teal */
      rgba(0, 51, 51, 0) 120%
  );
  box-shadow: 0 0 5px rgba(0, 204, 153, 0.7), /* Glowing Neon Turquoise */
  0 0 5px rgba(0, 153, 153, 0.7), /* Glowing Neon Teal */
  0 0 5px rgba(102, 255, 204, 0.7); /* Glowing Bright Aqua */
}

.animated-border-box:after {
  content: '';
  position: absolute;
  z-index: -1;
  /* border width */
  left: 5px;
  top: 5px;
  /* double the px from the border width left */
  width: calc(100% - 10px);
  height: calc(100% - 10px);
  /*bg color*/
  background: #ffffff;
  /*box border radius*/
  border-radius: 10px;
}

.border-box-temp-glow {
  border: 3px solid #003333;
  animation: glow-temp 2s infinite;
}

@keyframes glow-temp {
  0%, 100% {
    box-shadow: 0 0 5px 7px rgba(1, 149, 149, 0.5);
  }
  50% {
    box-shadow: 0 0 5px 7px rgba(1, 149, 149, 0.7);
  }
}

@keyframes rotate {
  100% {
    transform: translate(-50%, -50%) rotate(1turn);
  }
}

.center-box{
  display: flex;
  justify-content: center;
  align-items: flex-start;
  margin-top: 2vh;
}

.reveal-btn {
  background-color: #003333;
  color: #ffffff;
  border: none;
  padding: 12px 0;
  border-radius: 5px;
  font-size: 20px;
  width: 100%
}

.title-reveal-pricelist-section {
  color: #003333;
  font-size: 16px;
  font-family: DINosaur-a, sans-serif;
  font-weight: 400;
}

.important-word {
  font-weight: 600;
  text-decoration: underline;
  margin-left: 0.2em;
  margin-right: 0.2em;
}

.tc-pp {
  color: #a3a3a3;
  font-size: 14px;
  font-family: DINosaur-a, sans-serif;
  font-weight: 400;
  font-style: italic;
}

.tcpp-link {
  color: rgba(0, 148, 253, 0.7);
  cursor: pointer;
  font-weight: 500;
}

.join-now {
  color: #003333;
  font-size: 16px;
  font-family: DINosaur-a, sans-serif;
  font-weight: 500;
  font-style: italic;
}

.join-now-link {
  color: rgba(0, 148, 253, 1);
  cursor: pointer;
  font-weight: 600;
}

.mt-10 {
  margin-top: 10px;
}

.mt-5 {
  margin-top: 5px;
}

.el-divider--horizontal {
  margin: 10px 0;
}

.el-form-item__content {
  line-height: normal;
}

@media (min-width: 750px) {
  .title-reveal-pricelist-section {
    font-size: 22px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/propertyDetails/priceListSection.vue